import React from "react";
import { Box, CircularProgress, Divider, LinearProgress, Paper, useTheme } from "@mui/material";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../common/state/model/ApplicationState";

export function SoAdminCard({ header, isLoading = false, children }: { header: string; isLoading?: boolean; children: React.JSX.Element }): React.JSX.Element {
  const theme = useTheme();
  const isLoadingPerspective = useSelector((state: ApplicationState) => state.common?.isLoadingPerspective);

  return (
    <Paper variant="outlined">
      <Box style={{ padding: 10 }} sx={{ bgcolor: theme.palette.secondary.main, color: theme.palette.secondary.contrastText }}>
        {header}
      </Box>
      <Divider light />
      {isLoadingPerspective ? (
        <div style={{ display: "flex", justifyContent: "center", margin: 20 }}>
          <CircularProgress size={100} />
        </div>
      ) : (
        <>{children}</>
      )}
      {isLoading && <LinearProgress />}
    </Paper>
  );
}
